import { AccessPoint } from "./accessPoint";

export class AccessGroupPoint {
  id:number;
  accessPoint:AccessPoint;
}
